import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { store } from "react-notifications-component";
import ButtonFilled from "../../../components/FormElements/ButtonFilled";
import branchApi from "../../../store/branchStore/branchApi";
import styles from './styles.module.scss';
import Modal from "react-modal";
import SendCertificateModal from "../SendCertificateModal";

const backSvg = (
	<svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11 1L2 10L11 19" stroke="#1D1F23" strokeWidth="2" strokeLinecap="round"/>
	</svg>
);

const copySvg = (
	<svg width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.67357 5.11865H3C1.89543 5.11865 1 6.01408 1 7.11865V22.5696C1 23.6742 1.89543 24.5696 3 24.5696H14.356C15.4606 24.5696 16.356 23.6742 16.356 22.5696V21.4985" stroke="#AFAFAB" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M7.89453 2C7.89453 1.30964 8.45418 0.75 9.14453 0.75H20.5005C21.1909 0.75 21.7505 1.30965 21.7505 2V17.4509C21.7505 18.1413 21.1909 18.7009 20.5005 18.7009H9.14453C8.45418 18.7009 7.89453 18.1413 7.89453 17.4509V2Z" stroke="#AFAFAB" strokeWidth="1.5"/>
	</svg>
);

const options = {
	chartArea: {
		height: '100%',
		width: '100%',
	},
	legend: 'none',
	colors: ['#73D389', '#705AFB'],
	slices: {0: {offset: 0}, 1: {offset: 0}},
	pieSliceBorderColor: "none",
	pieSliceTextStyle: {fontName: 'graphic', fontSize: 22, bold: true}
};

const Info = () => {
	const { t, i18n } = useTranslation();
	const [dates, setDates] = useState({
		from: new Date().setFullYear(new Date().getFullYear() - 1),
		to: null,
	})
	const history = useHistory();
	const { info, pending: infoPending } = useSelector((s) => s.branchReducer);
	const [changingStatus, setChangingStatus] = useState(false);

	const {certificateId} = useParams()
	const [loading, setLoading] = useState(false)
	const [sendCertificateModal, setSendCertificateModal] = useState(false)
	const [certificate, setCertificate] = useState(null)

	const getCertificates = async () => {
		if (!info?.id) return

		try {
			setLoading(true)
			const certificatesData = await branchApi.getBranchCertificates(info?.id)
			const foundCertificate = certificatesData?.data?.find(certificate => certificate.id === certificateId)
			if (foundCertificate?.id) {
				setCertificate(foundCertificate)
			} else {
				history.push('/profile/certificate')
			}
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (!certificateId) {
			history.back();
		} else {
			getCertificates()
		}
	}, [info?.id]);

	const getBackToClients = () => {
		history.goBack();
	}

	const showData = (field, data) => {
		if (data) {
			return data;
		}
		if (certificate) {
			return certificate[field]
		}

		return null
	}

	const onCopyShareLink = (text) => (event) => {
		event.preventDefault();
		event.stopPropagation ? event.stopPropagation() : (event.cancelBubble=true);
		navigator.clipboard.writeText(text);

		store.addNotification({
			title: t('Notify.linkCopied'),
			message: text,
			type: "success",
			insert: "top",
			container: "top-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 5000,
				onScreen: true
			}
		});
	}

	const onChangeStatus = async (status) => {
		setChangingStatus(true)
		try {
			const formData = new FormData();
			formData.append('status', status);
			await branchApi.putBranchCertificate(info?.id, certificateId, formData)
			await getCertificates()
		} finally {
			setChangingStatus(false)
		}
	}

	const closeSendCertificateModal = () => {
		setSendCertificateModal(false)
	}

	return (
		<div className={styles.container}>
			<i
				aria-hidden="true"
				style={{position: "absolute", left: 9, top: 27, cursor: 'pointer'}}
				onClick={getBackToClients}
			>{backSvg}</i>
			<div className={styles.topData}>
				<div className={`data-view ${loading ? 'data-view--loading' : ''}`}>
					<div className="data-view__column">

						<div className="data-view__item">
							<div className="data-view__item-title">
								<b>{t('header')}:</b>
							</div>
							<div className="data-view__item-data">
								<span>{showData('header')}</span>
							</div>
						</div>

						<div className="data-view__item">
							<div className="data-view__item-title">
								<b>{t('NSCumulative.amount')}:</b>
							</div>
							<div className="data-view__item-data">
								<span>{showData('bonus_amount')}</span>
							</div>
						</div>

						<div className="data-view__item">
							<div className="data-view__item-title">
								<b>{t('Certificate.burnPeriod')}:</b>
							</div>
							<div className="data-view__item-data">
								<span>{certificate?.expiration_days} {t('NSPlural.days')}</span>
							</div>
						</div>

						<div className="data-view__item">
							<div className="data-view__item-title">
								<b>{t('status')}:</b>
							</div>
							<div className="data-view__item-data">
								{certificate?.status === 'active' ? (
									<span style={{ color: '#4EB78B' }}>{t('NSComparison.activated')}</span>
								) : (
									<span style={{ color: '#FA6262' }}>{t('NSComparison.disabled')}</span>
								)}
							</div>
						</div>

						{certificate && (
							<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginTop: '20px', gap: 16 }}>
								{!certificate?.status === 'active' ? (
									<ButtonFilled onClick={() => onChangeStatus('active')} loading={changingStatus} disabled={infoPending}>{t('NSComparison.activate')}</ButtonFilled>
								) : (
									<ButtonFilled onClick={() => onChangeStatus('deactivated')} loading={changingStatus} disabled={infoPending} variant="red">{t('NSComparison.deactivate')}</ButtonFilled>
								)}
								<ButtonFilled onClick={() => setSendCertificateModal(true)} disabled={infoPending}>{t('Certificate.sendCertificate')}</ButtonFilled>
							</div>
						)}

					</div>
					<div className="data-view__column">
						{/*<div className="data-view__item">*/}
						{/*	<div className="data-view__item-title">*/}
						{/*		<b>{t('Certificate.givenAmount')}:</b>*/}
						{/*	</div>*/}
						{/*	<div className="data-view__item-data">*/}
						{/*		<span>{showData('users_count')}</span>*/}
						{/*	</div>*/}
						{/*</div>*/}
						<div className="data-view__item">
							<div className="data-view__item-title">
								<b>{t('NSGeneral.clients')}:</b>
							</div>
							<div className="data-view__item-data">
								<span>{showData('client_amount')}</span>
							</div>
						</div>
						<div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 20 }}>
							<div className="data-view__item-title">
								<b>{t('description')}:</b>
							</div>
							<div className="data-view__item-content">
								<span>
									{showData('description')}
								</span>
							</div>
						</div>

						{certificate?.image_url && (
							<div style={{
								backgroundImage: `url(${certificate?.image_url})`,
								maxHeight: 200,
								maxWidth: 200,
								width: '100%',
								height: '100%',
								backgroundSize: 'contain',
								backgroundRepeat: 'no-repeat',
								borderRadius: 2,
							}}/>
						)}
					</div>
				</div>
			</div>


			<SendCertificateModal
				isOpen={sendCertificateModal}
				setModal={closeSendCertificateModal}
				certificate={certificate}
			/>
		</div>
	)
}

export default Info;